import type { AuthStaffDO } from "@/types/auth";

type PortalUser = Pick<AuthStaffDO, "role" | "isOwner"> | null | undefined;

export const canViewFinances = (user: PortalUser) =>
  user?.role === "Admin" || user?.role === "Manager";

export const canWithdrawFromFinances = (user: PortalUser) =>
  user?.role === "Admin" && user.isOwner;

export const canShareViaWhatsApp = (user: PortalUser) =>
  user?.role === "Manager" || (user?.role === "Admin" && user.isOwner);

export const canManageWhatsAppConnection = (user: PortalUser) =>
  user?.role === "Admin" && user.isOwner;
